<template>
	<div class="flex flex-col md:flex-row">
		<!-- product summary title
            ? to do: use component ? -->
		<div class="order-1 md:hidden space-y-2 px-4 pt-4 pb-0">
			<h1 class="flex items-baseline gap-x-4">
				<span class="text-4xl font-bold text-gray-700">{{
					$cropOptions.getLocalizedLabel(
						offer.product.grade,
						$cropOptions.productGradeOptions
					)
				}}</span>
				<span class="text-xl text-gray-500 font-semibold">{{
					offer.product.origin
				}}</span>
				<span class="text-xl text-gray-500 font-semibold">{{
					offer.product.harvest
				}}</span>
			</h1>
			<div class="text-xl text-gray-500 font-semibold">
				{{ $cropOptions.dateToString(offer, locale) }}
			</div>
		</div>

		<!-- left column -->
		<div
			class="order-3 md:order-2 md:w-2/3 divide-gray-200 divide-y overflow-y-auto"
		>
			<ui-alert-errors
				v-if="otherErrorMessages.length > 0"
				:messages="otherErrorMessages"
			/>

			<!-- product summary title
                ? to do: use component ? -->
			<div class="hidden md:block space-y-2 p-4">
				<h1 class="flex items-baseline gap-x-4">
					<span class="text-4xl font-bold text-gray-700">{{
						$cropOptions.getLocalizedLabel(
							offer.product.grade,
							$cropOptions.productGradeOptions
						)
					}}</span>
					<span class="text-xl text-gray-500 font-semibold">{{
						offer.product.origin
					}}</span>
					<span class="text-xl text-gray-500 font-semibold">{{
						offer.product.harvest
					}}</span>
				</h1>
				<div class="text-xl text-gray-500 font-semibold">
					{{ $cropOptions.dateToString(offer, locale) }}
				</div>
			</div>

			<bid-section label="Quality" :show-reference="showReference">
				<template v-slot:bid class="">
					<crop-quality-summary
						:tradable="offer"
						ul-class="flex flex-wrap"
						li-class="w-1/2"
					/>
				</template>
			</bid-section>

			<bid-section label="Location" :show-reference="showReference">
				<template v-slot:bid>
					{{ $cropOptions.locationToString(offer, locale) }}
				</template>
			</bid-section>

			<bid-section label="Contract Conditions" :show-reference="showReference">
				<template v-slot:bid>
					<auction-extra-summary :tradable="offer" />
				</template>
			</bid-section>

			<div>
				<label
					class="p-4 block font-medium text-gray-700 hyphens col-span-12 md:col-span-2"
				>
					{{ __("Validity") }}
				</label>
				<div data-v-0f0a6d18="" class="p-4 col-span-12">
					{{ __("Heute") }} {{ bidValidityTime }} Uhr
				</div>
			</div>
		</div>

		<!-- right column -->
		<div class="order-2 md:order-3 md:w-1/3 p-4">
			<!-- product sell box
                ? to do: use component ? -->
			<div
				class="border border-gray-200 divide-y divide-gray-200 rounded-xl overflow-hidden"
			>
				<div class="bg-gray-700 px-4 py-2 text-white font-semibold">
					{{ __("Auktionsmenge") }}
				</div>

				<!-- price -->
				<div class="px-4 pt-4 pb-6">
					<div class="price text-gray-700 text-3xl font-bold">
						<span v-html="offer.auction.qty_mt" /> t<span class="text-2xl"
							>, ca.</span
						>
					</div>
				</div>

				<div class="px-4 pt-4 pb-6">
					<label class="block font-medium text-gray-700">{{
						__("Preis")
					}}</label>
					<ui-select
						class="w-[7rem]"
						v-model="pricingStrategy"
						:options="pricingStrategyOptions"
						:allow-empty="false"
						:markInvalid="commodityIsExpired"
					/>
					<ui-validation-message :form="form" :field="'bid.price'" />
					<span v-if="form.price.type == 'FLAT'">
						<ui-input-group
							label="Preis/Preis Basis"
							:required="true"
							:form="form"
							field="price.mt"
							@change="piNeedsUpdate = true"
							v-model="form.price.mt"
							class="mt-3"
							:dp="2"
							suffix="€/t"
							:showAsInvalid="commodityIsExpired"
						/>
					</span>
					<span v-else-if="form.price.type == 'INDEXED'">
						<ui-input-group
							label="Preis/Preis Basis"
							:required="true"
							:form="form"
							field="price.basis"
							v-model="form.price.basis"
							class="mt-3"
							:dp="2"
							suffix="€/t"
							:showAsInvalid="commodityIsExpired"
						/>
					</span>
				</div>
				<!-- qty and button -->
				<div class="px-4 pt-4 pb-6">
					<ui-button
						class="text-xl mb-4 w-full"
						type="primary"
						v-on:click="$emit('tryGotoStepIfFormValid')"
						:label="submitButtonCaption"
					/>

					<p>{{ __("You can check your offer in the next step") }}</p>

					<ui-button
						class="text-xl mt-4 w-full"
						type="primary-reverted"
						v-if="hasBid && canRemoveBid"
						label="Gebot stornieren"
						@click="showBidRemoveModal = true"
					/>
				</div>
			</div>
		</div>
		<auction-remove-bid-modal
			:offer="offer"
			v-if="showBidRemoveModal"
			v-on:close="showBidRemoveModal = false"
		></auction-remove-bid-modal>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		offer: {
			type: Object,
			required: true,
		},
		bid: {
			type: Object,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
		otherErrors: {
			type: Object,
			required: false,
		},
		showReference: {
			type: Boolean,
			default: true,
		},
		canRemoveBid: {
			type: Boolean,
			default: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		bidValidityTime: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			// showReference: true,
			showBidRemoveModal: false,
		};
	},
	computed: {
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
		priceGrid() {
			return {
				cols: "5",
				flat: {
					colSpan: [2],
				},
				indexed: {
					colSpan: [3, 2],
				},
			};
		},
		hasBid() {
			return this.offer.auctionBids.length > 0;
		},
		submitButtonCaption() {
			return this.hasBid ? "Preis anpassen" : "Gebot abgeben";
		},
		futuresOptions() {
			let tickers = {
					RAPE: "ECO",
					MAIZE: "EMA",
					FABA: null, // no futures available for FABA and PEA
					PEA: null,
				},
				desiredTicker = tickers[this.form.product.type] || "EBM";
			return (this.activeFutures || [])
				.filter((f) =>
					this.form.product.type == "MAIZE"
						? f.ticker_code == desiredTicker || f.ticker_code == "EBM"
						: f.ticker_code == desiredTicker
				)
				.sort((a, b) =>
					a.ticker_code > b.ticker_code
						? 1
						: b.ticker_code > a.ticker_code
						? -1
						: 0
				);
		},
		pricingStrategyOptions() {
			let o = [{ id: "FLAT.", label: this.__("Flat Price") }],
				o2 = [];
			//if (this.offer.trade == "BUY") {
			o2 = this.futuresOptions.map(function (f) {
				return {
					id: "INDEXED." + f.id,
					label: f.name,
				};
			});
			//}
			return o.concat(o2);
		},

		// a pricing strategy is either flat or indexed.<commodity future id>
		pricingStrategy: {
			get() {
				if (this.form.price.type == "FLAT") {
					return "FLAT.";
				} else if (this.form.price.type == "INDEXED") {
					return "INDEXED." + this.form.price.commodity_future_id;
				} else {
					throw "unknown price type: " + this.form.price.type;
				}
			},
			set(v) {
				let [priceType, commodityFutureId] = v.split(".");
				this.form.price.type = priceType;
				this.form.price.commodity_future_id =
					commodityFutureId == "" ? null : commodityFutureId;
				console.log(this.form.price.type);
			},
		},
		commodityIsExpired() {
			if (this.offer.commodityFuture && this.offer.commodityFuture.expired) {
				return true;
			}
			return false;
		},
	},
};
</script>

<style scoped>
.hyphens {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
